import '../app/shared/sentry/init'

import { Suspense } from 'react'
import * as ReactDOM from 'react-dom/client'
import { Outlet, RouterProvider, createBrowserRouter } from 'react-router-dom'

import '../../styles/charts.css'
import '../../styles/modal.css'
import '../../styles/tailwind.css'
import '../../styles/timeframe-bar.css'
import { RouterErrorElement } from './components/error-view'
import { LoadingScreen } from './components/loading'
import { NotificationWrapper } from './components/notification'
import { SettingsContext } from './context'
import { portfolioModule } from './modules/portfolio'
import { quoteModule } from './modules/quote'
import { lazyLoadComponent } from './util-routing'
import { defineLazyRoutes } from './util-routing'

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <Suspense fallback={<LoadingScreen />}>
        <SettingsContext.Provider value={FinvizSettings}>
          <NotificationWrapper>
            <Outlet />
          </NotificationWrapper>
        </SettingsContext.Provider>
      </Suspense>
    ),
    ErrorBoundary: RouterErrorElement,
    children: defineLazyRoutes([
      ...portfolioModule,
      ...quoteModule,
      {
        path: '/charts',
        Component: lazyLoadComponent({
          chunkName: 'charts',
          load: () => import(/* webpackChunkName: "charts" */ './modules/charts'),
        }),
      },
      {
        path: '/save_to_portfolio.ashx',
        Component: lazyLoadComponent({
          chunkName: 'save-to-portfolio',
          load: () => import(/* webpackChunkName: "save-to-portfolio" */ './modules/save-to-portfolio/Route'),
        }),
      },
      {
        path: '/create_alert.ashx',
        Component: lazyLoadComponent({
          chunkName: 'create-alert',
          load: () => import(/* webpackChunkName: "create-alert" */ './modules/create-alert/Route'),
        }),
      },
    ]),
  },
])

const rootEl = document.getElementById('root')
const root = ReactDOM.createRoot(rootEl!)

root.render(<RouterProvider router={router} />)
